function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#0F62FE",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 9.5H4v-1h3v-2H4v-4h4v1H5v2h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 0H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM1 11V1h10v10H1z"
}));
const SvgNumber5Box = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNumber5Box, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/number-5-box.41193176.svg";
export { ForwardRef as ReactComponent };